import { useEffect, useState } from 'react'
import { IconChecklist } from '@tabler/icons-react'
import type { Patient } from '@medplum/fhirtypes'
import { useBoardList } from '@/pages/Boards/hooks'
import { ACTION_BUTTON_STYLE } from '../patientChartActionStyle'
import { CreateTaskModal } from './CreateTaskModal'

/**
 * Chart-header entry point for PD-1588. Renders nothing for a user with no
 * boards — board access is the feature's only gate.
 */
export const CreateTaskAction = ({ patient }: { patient: Patient }) => {
  const [opened, setOpened] = useState(false)
  const { data } = useBoardList()
  // Chart → chart navigation re-renders this rather than remounting it, so an
  // open modal would follow the user onto the next patient (Greptile !1614).
  useEffect(() => setOpened(false), [patient.id])
  if (!data?.boards.length) return null

  return (
    <>
      <button
        type="button"
        onClick={() => setOpened(true)}
        style={{
          ...ACTION_BUTTON_STYLE,
          background: '#fff',
          borderColor: '#3b82f6',
          color: '#3b82f6',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#eff6ff'
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#fff'
        }}
      >
        <IconChecklist size={14} stroke={2.5} />
        <span>Create task</span>
      </button>
      <CreateTaskModal patient={patient} opened={opened} onClose={() => setOpened(false)} />
    </>
  )
}
